import Vue from 'vue'
import md5 from 'js-md5';
import vue from "../main";

// 时间戳转时间 now：当前时间  type:1 年月日时分秒  else
function ZHDate(now, type) {
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let date = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type == 1) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type == 2) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type == 6) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else {
    return year + "-" + getzf(month) + "-" + getzf(date)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

function goBack() {
  vue.$router.go(-1)
}
function goBack2() {
  vue.$router.go(-2)
}
const tools = {
  ZHDate,
  goBack,

  goBack2
}

Vue.prototype.$md5 = md5;
Vue.prototype.$tools = tools;

